import { render } from "./ViewPurchaseRequest.vue?vue&type=template&id=a9b8c3b0&scoped=true"
import script from "./ViewPurchaseRequest.vue?vue&type=script&lang=js"
export * from "./ViewPurchaseRequest.vue?vue&type=script&lang=js"

import "./ViewPurchaseRequest.vue?vue&type=style&index=0&id=a9b8c3b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b8c3b0"]])

export default __exports__